export enum SectionPanelKeyHash {
  Description = 'DESCRIPTION',
  PrivateNote = 'PRIVATE_NOTE',
  TaskFields = 'TASK_FIELDS',
  Attachments = 'ATTACHMENTS',
  SubTasks = 'SUB_TASKS',
  DependentTasks = 'DEPENDENT_TASKS',
  Csat = 'CSAT',
  JiraIssues = 'JIRA_ISSUES',
  JiraLinkIssue = 'JIRA_LINK_ISSUE',
  TimeEntrySetting = 'TIME_ENTRY_SETTING',
  Effort = 'EFFORT',
}
